(() => {
  const imageLoadErrorCounts = window.WeakMap ? new WeakMap() : new Map();

  document.addEventListener('error', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (!elem.matches('.swinger-slider__item .swinger-image__image')) {
      return;
    }

    let count = imageLoadErrorCounts.get(elem) || 0;

    count += 1;
    imageLoadErrorCounts.set(elem, count);

    if (count !== 2) {
      return;
    }

    const sliderItem = elem.closest('.swinger-slider__item');

    sliderItem.parentNode.removeChild(sliderItem);
  }, true);
})();
